import React from "react";
import { getContentPageProps, getUniqueIdForContentTypeAlias } from "../../logic/contentLogic";

const FullscreenText = React.lazy(() => import("../../components/Magazine/modules/fullscreenTextContainer/FullscreenTextContainer.js"));

export const renderFullscreenText = (content, props = {}) => {
  return <FullscreenText key={getUniqueIdForContentTypeAlias(content.contentTypeAlias)} content={content} {...getContentPageProps(content)} />;
};
